import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-opening',
  templateUrl: './website-opening.component.html',
  styleUrls: ['./website-opening.component.css']
})
export class WebsiteOpeningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
